import React from "react";
// import { Dropdown } from "antd";
import { Menu, Dropdown } from "antd";
import classes from "./navTabs.module.css";
import SubMenu from "antd/lib/menu/SubMenu";
import { MenuItem } from "rc-menu";
import { useSpreadSheet } from "../../context/spreadsheet-context";
import { UndoOutlined, RedoOutlined, ScissorOutlined, CopyOutlined, SnippetsOutlined, FontSizeOutlined, FormatPainterOutlined, RightOutlined } from "@ant-design/icons";
import "./menu.css";

export const EditTab = () => {
  const isMobile = window.screen.width < 769;

  const { spreadsheetInstanceRef } = useSpreadSheet();
  // const passFunc = () => console.log('CLICKED')
  // const forPass = () => {
  //   console.log('PASSED');
  // };

  const forUndo = () => {
    // console.log(spreadsheetInstanceRef.current.data.canUndo());
    const { sheet } = spreadsheetInstanceRef.current;
    sheet.data.undo();
    sheet.table.render();
  };

  const forRedo = () => {
    // console.log(spreadsheetInstanceRef.current.data.canUndo());
    const { sheet } = spreadsheetInstanceRef.current;
    sheet.data.redo();
    sheet.table.render();
  };

  const forCut = () => {
    // console.log(spreadsheetInstanceRef.current.data.canUndo());
    const { sheet } = spreadsheetInstanceRef.current;
    sheet.data.cut();
    sheet.table.render();
  };

  const forCopy = () => {
    // console.log(spreadsheetInstanceRef.current.data.canUndo());
    const { sheet } = spreadsheetInstanceRef.current;
    sheet.data.copy();
    sheet.table.render();
  };

  const forPaste = (type) => {
    // console.log(spreadsheetInstanceRef.current.data.canUndo());
    const { sheet } = spreadsheetInstanceRef.current;
    // all | text | format
    sheet.data.paste(type);
    sheet.table.render();
  };

  const menu = (
    <Menu className="file-menu">
      <MenuItem key="sub1" onClick= { forUndo }>
          <span className="file-menu-item"><span className="file-menu-item-left"><UndoOutlined /></span><span className="file-menu-item-text">Undo</span></span>
        </MenuItem>
      <MenuItem key="sub2" onClick= { forRedo }>
          <span className="file-menu-item"><span className="file-menu-item-left"><RedoOutlined /></span><span className="file-menu-item-text">Redo</span></span>
        </MenuItem>
      <Menu.Divider />
      <MenuItem key="sub3" onClick= { forCut }>
          <span className="file-menu-item"><span className="file-menu-item-left"><ScissorOutlined /></span><span className="file-menu-item-text">Cut</span></span>
        </MenuItem>
      <MenuItem key="sub4" onClick= { forCopy }>
          <span className="file-menu-item"><span className="file-menu-item-left"><CopyOutlined /></span><span className="file-menu-item-text">Copy</span></span>
        </MenuItem>
      <MenuItem key="sub5" onClick= {() => forPaste('all')}>
          <span className="file-menu-item"><span className="file-menu-item-left"><SnippetsOutlined /></span><span className="file-menu-item-text">Paste</span></span>
        </MenuItem>
      <SubMenu key="sub6" popupClassName="file-menu-submenu" title={<span className="file-menu-item"><span className="file-menu-item-left"><SnippetsOutlined /></span><span className="file-menu-item-text">Paste with</span><span className="file-menu-item-arrow"><RightOutlined /></span></span>}>
      <MenuItem key="sub6.1" onClick= {() => forPaste('text')}>
          <span className="file-menu-item"><span className="file-menu-item-left"><FontSizeOutlined /></span><span className="file-menu-item-text">Values</span></span>
        </MenuItem>
      <MenuItem key="sub6.2" onClick= {() => forPaste('format')}>
          <span className="file-menu-item"><span className="file-menu-item-left"><FormatPainterOutlined /></span><span className="file-menu-item-text">Format</span></span>
        </MenuItem>
      </SubMenu>
      {/* <SubMenu key="sub1" title="ITEM 1??">
          <MenuItem key='sub1.1'>
              <div>ITEM1</div>
          </MenuItem>
        </SubMenu>
        <SubMenu key="sub2" title="ITEM 2??">
          <MenuItem key='sub2.1'>
              <div>ITEM1</div>
          </MenuItem>
        </SubMenu>
        <SubMenu key="sub3" title="ITEM 3??">
          <MenuItem key='sub3.1'>
              <div>ITEM1</div>
          </MenuItem>
        </SubMenu>
        <SubMenu key="sub4" title="ITEM 4??">
          <MenuItem key='sub4.1'>
              <div>ITEM1</div>
          </MenuItem>
        </SubMenu> */}
    </Menu>
  );
  return (
    <Dropdown overlay={menu} trigger={["click"]} arrow>
      <div style={{fontSize:isMobile?'11px':'12px'}} className={classes.navTabButton} onClick={(e) => e.preventDefault()}>
        Edit
      </div>
    </Dropdown>
  );
};
